import React from 'react'
import styles from "./Templatepage.module.css"

const Templatefooter = () => {

    const date = new Date();
    const year = date.getFullYear();

    return (
        <footer class={styles.footer}>
            <div class={styles.container}>
                <p>&copy; {year} EditLatex. All rights reserved.</p>
            </div>
        </footer>
    )
}

export default Templatefooter